<template>
  <div class="outer-wrapper">
    <div class="button-wrapper">
      <Button
        class="print-button"
        slot="extra"
        v-print="printParams"
        key="to_single_print"
        >打印</Button
      >
    </div>
    <div id="to_single_print">
    <div class="content" >
      <div class="inner">
        <!-- <p class="table-no">表号：{{ purchasePackage.formNo }}</p> -->
        <p class="comnamech">上海赛恩工贸有限公司</p>
        <p class="comnameen">Shanghai Saien Industrial & Trading Co., Ltd.</p>
        <p class="title">申购单</p>
        <p class="sn">
          编号：<span>{{ purchasePackage.display_no }}</span>
        </p>
        <table class="purchase-form">
            <tr>
              <td style="width:3%;">序号</td>
              <td style="width:20%;">物品名称</td>
              <td style="width:5%;">类别</td>
              <td style="width:30%;">属性</td>
              <td style="width:5%;">申购数量</td>
              <td style="width:10%;">申购备注</td>
              <td style="width:10%;">采购状态</td>
              <td style="width:7%;">入库时间</td>
              <!-- <td style="width:5%;">操作</td> -->
            </tr>
            <tr v-for="(item,index) in itemList" :key="item.id">
              <td>{{ index+1 }}</td>
              <td>{{item.name}}</td>
              <td>{{revealCatagory(item.catagory)}}</td>
              <td>{{revealProperty(item.property)}}</td>
              <td>{{ item.amount }}
                {{item.pit}}</td>
              <td>{{ item.remark }}</td>
              <td>{{ item.purchase_time }}</td>
              <td>{{ item.warehousing_time }}</td>
              <!-- <td>
                <span @click="delItemFromCart(index)" class="del-b">
                  <Icon type="ios-trash-outline" size="24"/>
                </span>
              </td> -->
            </tr>
          </table>
          <div class="info-des">
            <p>申购人：{{ purchasePackage.create_account }}</p>
          <p>申购时间：{{ purchasePackage.create_time }}</p>
          <p>申购单备注：{{ purchasePackage.remark }}</p>
          </div>
          <div class="verify-des">
            <p>审核人：{{ purchasePackage.verify_account }}</p>
          <p>审核时间：{{ purchasePackage.verify_time }}</p>
          <p>审核备注：{{ purchasePackage.remark }}</p>
          </div>
        <!-- <p class="page">第1页 共{{purchasePackage.pronumList.length+1}}页</p> -->
      </div>
    </div>
    </div>
    <Modal
      v-model="modalValue.alterValueSelect"
      :width="1000"
      :mask-closable="false"
    >
      <i
        class="ivu-icon ivu-icon-ios-close"
        slot="close"
        @click="closeModal('alterValueSelect')"
      ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>报告内容修改（）</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="base">
            <tr>
              <td>
                <span> {{ currentText }}： </span>
              </td>
              <td style="text-align: left">
                <select v-model="currentValue">
                  <option
                    :value="item.url"
                    v-for="(item, index) in signatureList"
                    :key="index"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="alterSubmit">确定</Button>
        <Button size="large" @click="closeModal('alterValueSelect')"
          >取消</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
let authData = JSON.parse(localStorage.getItem("authData"));
let userToken = localStorage.getItem("current_user_token");

export default {
  name: "packageDetail",
  props: {
    packageId: {
      type: String,
    },
  },
  components: {},
  created() {
    this.getContent();
    this.getStaticOptionsData();
  },
  data() {
    return {
      purchasePackage: {},
      itemList: [],
      catagoryList: [],
      printParams: {
        id: "to_single_print",
        popTitle: "",
      },
      modalValue: {
        alterValue: false,
        alterValueSelect: false,
      },
      currentValue: "",
      currentKey: "",
      currentText: "",
      currentType: "text",
      signatureList: [],
      img1: process.env.BASE_URL + "img/mt1.jpg",
    };
  },
  methods: {
    getStaticOptionsData() {
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: "goodsOption"
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.catagoryList = response.data.res_record.catagoryList;
          } else {
            this.$Message.warning("请求选项数据失败！");
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    getContent() {
      this.$axios
        .post(this.$url + "/content", {
          userToken: userToken,
          askData: "packageDetail",
          enid: this.packageId,
        })
        .then((response) => {
          if (response.data.stat == "ok") {
            this.purchasePackage = response.data.purchasePackage;
            this.itemList = response.data.itemList
            this.$forceUpdate();
          } else {
            this.$Message.warning("未查到相关信息！");
          }
        });
    },
    alterInputClick(key, text, t = "text") {
      this.currentKey = key;
      this.currentText = text;
      this.currentValue = this.purchasePackage[key];
      this.currentType = t;
      this.openModal("alterValue");
    },
    alterSelectClick(key, text) {
      this.currentKey = key;
      this.currentText = text;
      this.currentValue = this.purchasePackage[key];
      this.openModal("alterValueSelect");
    },
    alterSubmit() {
      this.$axios
        .post(this.$url + "/content", {
          userToken: userToken,
          askData: "alterSingle",
          fid: this.fid,
          currentValue: this.currentValue,
          currentKey: this.currentKey,
        })
        .then((response) => {
          if (response.data.stat == "ok") {
            this.closeModal("alterValue");
            this.closeModal("alterValueSelect");
            this.getContent();
          } else {
            this.$Message.warning("数据更新失败！");
          }
        });
    },
    revealProperty(value) {
      let tmp;
      if (typeof value === "string" && value.length > 0) {
        tmp = JSON.parse(value);
      } else {
        tmp = {};
      }
      let text = "";
      if (tmp.spec) {
        text += "规格:" + tmp.spec + ";";
      }
      if (tmp.model) {
        text += "型号:" + tmp.model + ";";
      }
      if (tmp.mat) {
        text += "材质:" + tmp.mat + ";";
      }
      if (tmp.volume) {
        text += "容积:" + tmp.volume + ";";
      }
      if (tmp.brand) {
        text += "品牌:" + tmp.brand + ";";
      }
      if (tmp.seller) {
        text += "供货商:" + tmp.seller + ";";
      }
      if (tmp.diameter) {
        text += "外径:" + tmp.diameter + ";";
      }
      if (tmp.bore) {
        text += "内径:" + tmp.bore + ";";
      }
      if (tmp.thickness) {
        text += "壁厚:" + tmp.thickness + ";";
      }
      if (tmp.pressure) {
        text += "压力:" + tmp.pressure + ";";
      }
      if (tmp.standard) {
        text += "标准:" + tmp.standard + ";";
      }
      if (tmp.grade) {
        text += "级别:" + tmp.grade + ";";
      }
      if (tmp.other) {
        text += "其他:" + tmp.other + ";";
      }
      return text;
    },
    revealCatagory(value) {
      let tmp = this.catagoryList.find(val => val.value === value);
      let text = "";
      if (tmp) {
        text = tmp.text;
      }
      return text;
    },
    openModal(label) {
      this.modalValue[label] = true;
    },
    closeModal(label) {
      this.modalValue[label] = false;
    },
    urlTrans(url) {
      return this.$fileUrlFac(url, authData.sfileRight);
    },
  },
  computed: {},
};
</script>
<style scoped>
.outer-wrapper {
  margin: 0 auto;
  width: fit-content;
  text-align: center;
  padding: 10px 0 50px;
}

.button-wrapper {
  padding: 20px;
}
.content {
  width: 840.36pt;
  height: 594.3pt;
  color: #000;
  text-align: center;
  position: relative;
  margin: 1px;
  overflow: hidden;
}

@media screen {
  .divide-line {
    border-top: 1px solid #aaa;
  }
  .content {
    outline: #aaa solid 1px;
    margin-bottom: 10px;
    box-shadow: 1px 2px 1px #aaa;
  }
}

.inner {
  padding: 50pt;
}

.content .table-title {
  font-size: 14pt;
}

.content p {
  font-family: "Times New Roman", "宋体";
  font-size: 10pt;
  line-height: 24pt;
}

.content .table-no {
  position: absolute;
  top: 35pt;
  right: 50pt;
  font-size: 7pt;
  color: #999;
}

.content .comnamech {
  text-align: center;
  font-size: 16pt;
  font-weight: 600;
  letter-spacing: 8pt;
  margin-top: 8pt;
}

.content .comnameen {
  text-align: center;
  font-size: 12pt;
  font-weight: 600;
}

.content .title {
  text-align: center;
  font-size: 22pt;
  margin-top: 6pt;
  font-weight: 600;
  letter-spacing: 8pt;
}

.content .sn {
  text-align: right;
  font-size: 10pt;
  margin-top: 5pt;
}

table {
  border-collapse: collapse;
  width: 100%;
}
table td {
  border: 1px solid #333;
  text-align: center;
  padding: 3pt 5pt;
}


.inner-content-wrapper {
  margin: 0 auto;
  width: fit-content;
}

table.base td {
  border: none;
}

.info-des,.verify-des{
  text-align: left;
  font-size: 14px;
  padding: 5px 10px;
  border:1px solid #333;
  font-weight: 600;
}

.info-des{
  border-top:none;
  border-bottom: none;
}
.verify-des{
  border-top:3px double #333;
}


</style>